import KeyIcon from '@mui/icons-material/Key';
import ClassIcon from '@mui/icons-material/Class';
import GroupIcon from '@mui/icons-material/Group';
import ImageIcon from '@mui/icons-material/Image';
import LoginIcon from '@mui/icons-material/Login';
import AppleIcon from '@mui/icons-material/Apple';
import SchoolIcon from '@mui/icons-material/School';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import StorageIcon from '@mui/icons-material/Storage';
import ReceiptIcon from '@mui/icons-material/Receipt';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PasswordIcon from '@mui/icons-material/Password';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import DashboardIcon from '@mui/icons-material/Dashboard';
import WallpaperIcon from '@mui/icons-material/Wallpaper';
import TableViewIcon from '@mui/icons-material/TableView';
import AssignmentIcon from '@mui/icons-material/Assignment';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import DifferenceIcon from '@mui/icons-material/Difference';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import ConstructionIcon from '@mui/icons-material/Construction';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import EditICCBranchIcon from '../components/Admin/icons/EditICCBranchIcon';
import EditBillingUserIcon from '../components/Admin/icons/EditBillingUserIcon';
import EditBillingProductIcon from '../components/Admin/icons/EditBillingProductIcon';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';

export enum MenuHandlers {
    Startup = -1,

    Separator,

    InsightlyCRM = 1,
    WebsiteLogin,
    Supportbee,
    KnowledgeBase,
    PasswordSender,
    ClientOnlineReport,
    XeroAccounts,
    Voice,
    Purchases,
    Scheduler,
    Jira,
    Bitbucket,
    Apple,
    AppCenter,
    PricingALITProducts,
    EquipmentStockList,
    QuotesViewer,
    QuotePricingDrawing,
    ChangeLogs,

    ICC2Manual,
    ViewIccUsers,
    EditIccUser,
    CreateIccUser,
    CreateIccBranch,
    EditIccBranch,
    CreateDatabase,
    UpdateBoothId,
    ViewReportUser,
    EditReportUser,
    CreateReportUser,
    WorkflowNewCustomer,
    ReportImageGrouping,
    MonthlyUsageReport,
    BackupViewer,

    IosTechManual,
    EditMobileConfig,
    CreateMaskStructure,
    EditMaskStructure,
    UpdateMaskImages,

    BillingInstructionManual,
    CreateBilling,
    BillingSettings,
    EditBillingUser,
    CreateBillingUser,
    EditBillingProduct,
    CreateBillingProduct,
    BillingStatus,
    BillingSearch,

    CreateXeroInvoices,
    XeroTracking,
    XeroInvoiceStatus,

    Commission,
    SetupCommission,
    CommissionPayRoll,
    Deduplication,
    ViewAdminUsers,
    EditAdminUser,
    CreateAdminUser,
    RecoverAdminPassword,
    FeatureFlags,
}

export enum MenuCategories {
    ALITSystems = "alitSystems",
    ICCGeneral = "iccGeneral",
    Mobile = "mobile",
    Billing = "billing",
    Xero = "xero",
    Other = "other",
}

export interface AdminMenu {
    Icon: any;
    Handler: number;
    Type: string;
}

export const AdminMenus: Map<string, AdminMenu> = new Map([
    ["ALIT systems", { Icon: null, Handler: MenuHandlers.Separator, Type: MenuCategories.ALITSystems }],

    ["Insightly - CRM", { Icon: <ManageAccountsIcon />, Handler: MenuHandlers.InsightlyCRM, Type: MenuCategories.ALITSystems }],
    ["Website login", { Icon: <LoginIcon />, Handler: MenuHandlers.WebsiteLogin, Type: MenuCategories.ALITSystems }],
    ["Supportbee tickets", { Icon: <SupportAgentIcon />, Handler: MenuHandlers.Supportbee, Type: MenuCategories.ALITSystems }],
    ["Knowledge Base", { Icon: <SchoolIcon />, Handler: MenuHandlers.KnowledgeBase, Type: MenuCategories.ALITSystems }],
    ["Password sender", { Icon: <KeyIcon />, Handler: MenuHandlers.PasswordSender, Type: MenuCategories.ALITSystems }],
    ["Client online report", { Icon: <TableViewIcon />, Handler: MenuHandlers.ClientOnlineReport, Type: MenuCategories.ALITSystems }],
    ["Xero - Accounts", { Icon: <PointOfSaleIcon />, Handler: MenuHandlers.XeroAccounts, Type: MenuCategories.ALITSystems }],
    ["Voice - Phone software", { Icon: <PermPhoneMsgIcon />, Handler: MenuHandlers.Voice, Type: MenuCategories.ALITSystems }],
    ["Purchases", { Icon: <ShoppingBasketIcon />, Handler: MenuHandlers.Purchases, Type: MenuCategories.ALITSystems }],
    ["Scheduler", { Icon: <CalendarTodayIcon />, Handler: MenuHandlers.Scheduler, Type: MenuCategories.ALITSystems }],
    ["Jira - Dev. requests", { Icon: <DashboardIcon />, Handler: MenuHandlers.Jira, Type: MenuCategories.ALITSystems }],
    ["Bitbucket - code repository", { Icon: <StorageIcon />, Handler: MenuHandlers.Bitbucket, Type: MenuCategories.ALITSystems }],
    ["Apple Developer prog.", { Icon: <AppleIcon />, Handler: MenuHandlers.Apple, Type: MenuCategories.ALITSystems }],
    ["Apps Monitoring dashboard", { Icon: <CrisisAlertIcon />, Handler: MenuHandlers.AppCenter, Type: MenuCategories.ALITSystems }],
    ["Pricing - ALIT products", { Icon: <MonetizationOnIcon />, Handler: MenuHandlers.PricingALITProducts, Type: MenuCategories.ALITSystems }],
    ["Equipment stock list", { Icon: <ConstructionIcon />, Handler: MenuHandlers.EquipmentStockList, Type: MenuCategories.ALITSystems }],
    ["Quotes", { Icon: <RequestQuoteIcon />, Handler: MenuHandlers.QuotesViewer, Type: MenuCategories.ALITSystems }],
    ["Quote request", { Icon: <AssignmentIcon />, Handler: MenuHandlers.QuotePricingDrawing, Type: MenuCategories.ALITSystems }],
    ["Change logs", { Icon: <IntegrationInstructionsIcon />, Handler: MenuHandlers.ChangeLogs, Type: MenuCategories.ALITSystems }],

    ["ICC general", { Icon: null, Handler: MenuHandlers.Separator, Type: MenuCategories.ICCGeneral }],

    ["ICC tech manual", { Icon: <MenuBookIcon />, Handler: MenuHandlers.ICC2Manual, Type: MenuCategories.ICCGeneral }],
    ["ICC users-view", { Icon: <GroupIcon />, Handler: MenuHandlers.ViewIccUsers, Type: MenuCategories.ICCGeneral }],
    ["ICC user-edit", { Icon: <ManageAccountsIcon />, Handler: MenuHandlers.EditIccUser, Type: MenuCategories.ICCGeneral }],
    ["ICC user-create", { Icon: <PersonAddAltIcon />, Handler: MenuHandlers.CreateIccUser, Type: MenuCategories.ICCGeneral }],
    ["ICC branch-create", { Icon: <AddBusinessIcon />, Handler: MenuHandlers.CreateIccBranch, Type: MenuCategories.ICCGeneral }],
    ["ICC branch-edit", { Icon: <EditICCBranchIcon />, Handler: MenuHandlers.EditIccBranch, Type: MenuCategories.ICCGeneral }],
    ["Database-create", { Icon: <StorageIcon />, Handler: MenuHandlers.CreateDatabase, Type: MenuCategories.ICCGeneral }],
    ["BoothID-update", { Icon: <ClassIcon />, Handler: MenuHandlers.UpdateBoothId, Type: MenuCategories.ICCGeneral }],
    ["Online report-user", { Icon: <GroupIcon />, Handler: MenuHandlers.ViewReportUser, Type: MenuCategories.ICCGeneral }],
    ["Online report-edit", { Icon: <ManageAccountsIcon />, Handler: MenuHandlers.EditReportUser, Type: MenuCategories.ICCGeneral }],
    ["Online report-create", { Icon: <PersonAddAltIcon />, Handler: MenuHandlers.CreateReportUser, Type: MenuCategories.ICCGeneral }],
    ["Workflow: new customer", { Icon: <SensorOccupiedIcon />, Handler: MenuHandlers.WorkflowNewCustomer, Type: MenuCategories.ICCGeneral }],
    ["Report-image-grouping", { Icon: <PermMediaIcon />, Handler: MenuHandlers.ReportImageGrouping, Type: MenuCategories.ICCGeneral }],
    ["Monthly usage report", { Icon: <CalendarMonthIcon />, Handler: MenuHandlers.MonthlyUsageReport, Type: MenuCategories.ICCGeneral }],
    ["ICC backup-viewer", { Icon: <ManageHistoryIcon />, Handler: MenuHandlers.BackupViewer, Type: MenuCategories.ICCGeneral }],

    ["Mobile", { Icon: null, Handler: MenuHandlers.Separator, Type: MenuCategories.Mobile }],

    ["iOS tech manual", { Icon: <MenuBookIcon />, Handler: MenuHandlers.IosTechManual, Type: MenuCategories.Mobile }],
    ["ICC iOS config-edit", { Icon: <AppSettingsAltIcon />, Handler: MenuHandlers.EditMobileConfig, Type: MenuCategories.Mobile }],
    ["Mask structure-create", { Icon: <AddPhotoAlternateOutlinedIcon />, Handler: MenuHandlers.CreateMaskStructure, Type: MenuCategories.Mobile }],
    ["Mask structure-edit", { Icon: <WallpaperIcon />, Handler: MenuHandlers.EditMaskStructure, Type: MenuCategories.Mobile }],
    ["Mask structure-update", { Icon: <ImageIcon />, Handler: MenuHandlers.UpdateMaskImages, Type: MenuCategories.Mobile }],

    ["Billing", { Icon: null, Handler: MenuHandlers.Separator, Type: MenuCategories.Billing }],

    ["Billing-Instruction manual", { Icon: <MenuBookIcon />, Handler: MenuHandlers.BillingInstructionManual, Type: MenuCategories.Billing }],
    ["Monthly inv's-preview", { Icon: <PointOfSaleIcon />, Handler: MenuHandlers.CreateBilling, Type: MenuCategories.Billing }],
    ["Client inv-edit/create", { Icon: <EditNoteIcon />, Handler: MenuHandlers.BillingSettings, Type: MenuCategories.Billing }],
    ["Billing user-edit", { Icon: <EditBillingUserIcon />, Handler: MenuHandlers.EditBillingUser, Type: MenuCategories.Billing }],
    ["Billing user-create", { Icon: <RecentActorsIcon />, Handler: MenuHandlers.CreateBillingUser, Type: MenuCategories.Billing }],
    ["Billing product-edit", { Icon: <EditBillingProductIcon />, Handler: MenuHandlers.EditBillingProduct, Type: MenuCategories.Billing }],
    ["Billing product-create", { Icon: <ReceiptIcon />, Handler: MenuHandlers.CreateBillingProduct, Type: MenuCategories.Billing }],
    ["Billing-3 month check", { Icon: <PriceCheckIcon />, Handler: MenuHandlers.BillingStatus, Type: MenuCategories.Billing }],
    ["Billing search", { Icon: <FindInPageIcon />, Handler: MenuHandlers.BillingSearch, Type: MenuCategories.Billing }],

    ["Xero", { Icon: null, Handler: MenuHandlers.Separator, Type: MenuCategories.Xero }],

    ["Create monthly invoices", { Icon: <NoteAddIcon />, Handler: MenuHandlers.CreateXeroInvoices, Type: MenuCategories.Xero }],
    ["Link tracking codes", { Icon: <PersonPinCircleIcon />, Handler: MenuHandlers.XeroTracking, Type: MenuCategories.Xero }],
    ["Unpaid Invoices", { Icon: <UnpublishedIcon />, Handler: MenuHandlers.XeroInvoiceStatus, Type: MenuCategories.Xero }],

    ["Other", { Icon: null, Handler: MenuHandlers.Separator, Type: MenuCategories.Other }],

    ["Commission-calculator", { Icon: <MonetizationOnIcon />, Handler: MenuHandlers.Commission, Type: MenuCategories.Other }],
    ["Commission-setup", { Icon: <SettingsSuggestIcon />, Handler: MenuHandlers.SetupCommission, Type: MenuCategories.Other }],
    ["Commission-payrolls", { Icon: <PointOfSaleIcon />, Handler: MenuHandlers.CommissionPayRoll, Type: MenuCategories.Other }],
    ["Deduplicate vehicles", { Icon: <DifferenceIcon />, Handler: MenuHandlers.Deduplication, Type: MenuCategories.Other }],
    ["Admin users-view", { Icon: <GroupIcon />, Handler: MenuHandlers.ViewAdminUsers, Type: MenuCategories.Other }],
    ["Admin users-edit", { Icon: <ManageAccountsIcon />, Handler: MenuHandlers.EditAdminUser, Type: MenuCategories.Other }],
    ["Admin users-create", { Icon: <PersonAddAltIcon />, Handler: MenuHandlers.CreateAdminUser, Type: MenuCategories.Other }],
    ["Admin password-recovery", { Icon: <PasswordIcon />, Handler: MenuHandlers.RecoverAdminPassword, Type: MenuCategories.Other }],
    ["Feature flags", { Icon: <GolfCourseIcon />, Handler: MenuHandlers.FeatureFlags, Type: MenuCategories.Other }],
]);
